import type { ExamType } from '@evidia/shared';
import type { PresetColorType } from 'antd/es/_util/colors';
import type { LiteralUnion } from 'antd/lib/_util/type';
import StyledTag from './Styled/Tag';

const COLOR_MAP: Record<
	ExamType,
	LiteralUnion<PresetColorType | 'success' | 'processing' | 'error' | 'default' | 'warning'>
> = {
	CV: 'blue',
	OUV: 'cyan',
	PJ: 'green',
	PSP: 'geekblue',
};

export const STUDENT_STATE_TEXT_MAP: Record<ExamType, string> = {
	CV: 'Cvičiště',
	OUV: 'Ovládání a údržba',
	PJ: 'Jízda',
	PSP: 'Teorie',
};

interface Props {
	type: ExamType;
	tag?: boolean;
}

const ExampType: React.FC<Props> = ({ type, tag = true }) => {
	if (tag) {
		return <StyledTag color={COLOR_MAP[type]}>{STUDENT_STATE_TEXT_MAP[type]}</StyledTag>;
	}

	return <>{STUDENT_STATE_TEXT_MAP[type]}</>;
};
export default ExampType;
